import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-photo[src][alt]',
  templateUrl: './photo.component.html',
  styleUrls: ['./photo.component.scss'],
})
export class PhotoComponent {
  @Input() src!: string;

  @Input() alt!: string;

  // constructor() {}
}
